// removes all inputs added dynamically with a.addInput selector
// by forcing a click event on their respective removals.
$('body').on('click', '.removeAllElements', function () {
  $(
    '.js-removeElement, a.removeElement, button.removeElement, input[type=button].removeElement'
  ).each(function () {
    $(this).trigger('click');
  });
});
